import "core-js/modules/es.array.push.js";
import Bus from '@/assets/js/bus.js';
import Tool, { addTabTitle, handleLocalStorage, returnSourceType, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { controlDeviceBehavior, controlAudio, controlDevicePublish } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
const nodeUrl = require('url');
export default {
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config,
      loginInfo: state => state.loginInfo,
      currentPartyInfo: state => state.currentPartyInfo,
      PageSerBusRequestWs: state => state.pageSerBusRequestWs
    }),
    dailogText() {
      return this.outputSourceType != 'shareScreen' ? this.$t('addWords.vfbSwitchToShare') : this.$t('addWords.shareSwitchToVfb');
    },
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.userInfo.rtilCode] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.userInfo.rtilCode] == 90) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull90';
        } else {
          _str += 'rotate90';
        }
      } else if (this.degreeHost[this.userInfo.rtilCode] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.userInfo.rtilCode] == 270) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull270';
        } else {
          _str += 'rotate270';
        }
      }
      return _str;
    }
  },
  data() {
    return {
      anywhereSettingShowMap: {},
      anyWhereRtilCodeObj: {},
      anyWhereVideoAudioInfo: null,
      anyWherePeerIds: {},
      deviceTypeMap: {},
      anyWherePlatForms: {},
      anyWhereSettings: {},
      anyWhereInfo: {
        show: false,
        rtilCode: ''
      },
      showUnread: false,
      localVolume: 0,
      fullRotate: false,
      devicePlatform: {},
      degreeHost: {},
      deviceType: {},
      externalJoinInfo: {},
      joinParam: {},
      sharePopover: false,
      initBackgroundImg: null,
      wsPageSTimer: null,
      allPartyMembers: [],
      loadChatBox: true,
      fullScreenShareCode: '',
      shareScreenType: null,
      dailogInfo: {
        show: false,
        title: 'commonFunction.switchMainWindow',
        cancel: 'pushParticipantSource.cancel',
        save: 'pushParticipantSource.confirm'
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      fullScreenTips: {
        title: 'kioskHost.fullScreenAuth',
        cancel: 'galleryParticipant.deny',
        save: 'kioskHost.done',
        show: false
      },
      extraChannel: {},
      allRtilList: [],
      rtc: {},
      userInfo: {},
      rtilList: [],
      outputRtilCode: '',
      PartyLineRequest: null,
      partyCode: '',
      behaviorInfo: {},
      externalPartyCode: null,
      channels: {},
      tagNameInfo: {},
      mic: true,
      showCloseFullScreenBtn: false,
      pipsListFullScreen: false,
      initShowCloseFullScreenBtn: false,
      clearFullScreenTimer: null,
      showUploadLogo: false,
      bgUrl: '',
      groupId: '',
      shareRtilCode: '',
      value: '',
      rList: [],
      selectOutputType: 'VFB',
      pullLoading: false,
      initLogoList: [],
      outPutTypeList: ['VFB', 'PP', 'PIP'],
      isShare: false,
      onlineTimer: null,
      rtcLoaded: false,
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      ChannelMode: {
        '-1': 'UNKNOWN',
        0: 'COMMON',
        1: 'GALLERY',
        2: 'CONFERENCE',
        3: 'EXTERNAL',
        4: 'SCENE',
        7: 'CANVAS',
        8: 'SECTION',
        9: 'COMMENTATOR_PARENT',
        12: 'COMMENTATOR'
      },
      outputSourceType: '',
      devicesInfo: {
        cameraList: [],
        microphoneList: [],
        cameraId: '',
        microphoneId: ''
      },
      setTagName: {
        show: false,
        tagName: ''
      },
      shareList: {},
      inonWindow: true,
      hideFullTimer: null,
      shareClient: null,
      allRList: [],
      batchMovePartyInfo: {
        show: false,
        rtilCodes: []
      },
      movePartyInfo: {
        show: false
      },
      outputRtilList: [],
      // 用于多个output
      firstLogoList: [],
      remoteNetWorks: {},
      mainWindowList: [{
        label: 'Source type',
        options: [{
          value: 'VFB',
          label: 'VFB (Receiver Video Return)'
        }, {
          value: 'PP',
          label: 'PP (Producer)'
        }, {
          value: 'pip',
          label: 'Participant'
        }, {
          value: 'PBP',
          label: 'PBP (2x Participants)'
        }, {
          value: 'shareScreen',
          label: 'Shared Screen'
        }]
      }],
      hadOpenWebCloud: false,
      globalOutputTimestamp: 0,
      partyOutputTimestamp: 0,
      viewPosition: {},
      globalControlId: '',
      isAudioLevel: false,
      oldMuteMicStatus: false,
      // 用来记录没有加入 Global Control 之前的状态
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: {}
    };
  },
  watch: {
    pipsListFullScreen: function (val) {
      if (val) {
        this.showCloseFullScreenBtn = true;
        this.initShowCloseFullScreenBtn = true;
        this.clearFullScreenTimer = setTimeout(() => {
          this.showCloseFullScreenBtn = false;
          this.initShowCloseFullScreenBtn = false;
        }, 1000 * 5);
      }
      if (!val) {
        clearTimeout(this.clearFullScreenTimer);
        this.clearFullScreenTimer = null;
        this.initShowCloseFullScreenBtn = true;
        this.showCloseFullScreenBtn = false;
        this.$refs.pipBox.style.background = '';
      }
    },
    'currentPartyInfo.code': function (newVal, oldVal) {
      if (oldVal) {
        this.initBackgroundImg = null;
        if (Object.keys(this.shareList).length) {
          this.stopShare({
            id: this.shareScreenType === 'pip' ? this.shareRtilCode : this.outputRtilCode
          }, 'byClickShareIcon');
        }
        this.shareList = {};
        // 需要额外添加 Global Control下面的 ws
        if (this.globalControlId) {
          this.State.pageSerBusRequestWs[this.globalControlId] && this.State.pageSerBusRequestWs[this.globalControlId].close();
          this.$delete(this.State.pageSerBusRequestWs, this.globalControlId);
        }
        this.State.pageSerBusRequestWs[oldVal] && this.State.pageSerBusRequestWs[oldVal].close();
        this.$delete(this.State.pageSerBusRequestWs, oldVal);
        this.$refs.kioskBox.style.background = '';
        this.rtilList = [];
        this.State.selectLogoInfo = {};
        this.State.hadSelectUpLogo = [];
      }
      this.userInfo = {};
      if (!newVal) return;
      this.initJoinFn(newVal);
    },
    'State.batchMoveParticipate': function (val) {
      this.batchMovePartyInfo.show = val;
      if (!val) {
        this.batchMovePartyInfo.rtilCodes = [];
      }
    },
    'State.showChatMessage': function () {
      this.$nextTick(() => {
        this.$refs.participantList && this.$refs.participantList.changeCanvasView();
      });
    }
  },
  created() {
    // 添加鼠标移动监听
    window.addEventListener('mousemove', () => {
      if (!this.pipsListFullScreen) return;
      this.showCloseFullScreenBtn = true;
      if (this.hideFullTimer) clearTimeout(this.hideFullTimer);
      this.hideFullTimer = setTimeout(() => {
        this.showCloseFullScreenBtn = false;
      }, 5000);
    });
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    /**
     * @params 重构新加代码开始
     */
    const URL = nodeUrl.parse(location.href, true);
    if (URL.query.id) {
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(URL.query.id);
      const illegalPartyCode = hasLetters ? URL.query.id : '';
      URL.query.id = URL.query.id.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
      if (URL.query.id.length > 20 || URL.query.id.length < 9) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      this.getPartyInfo(URL.query.id, illegalPartyCode);
    }
    /**
     * @params 重构新加代码结束
     */
    document.addEventListener('fullscreenerror', this.showFullScreenTips);
    Tool.judgeVerticalScreen();
    window.addEventListener('resize', this.calculatorArea);
    this.getReceiverList();
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(与会者、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    Bus.$on('viewPositionV2', result => {
      this.viewPosition = result;
      const rtilCodes = result.total;
      rtilCodes.forEach(v => {
        if (this.channels[v] && this.channels[v].shareCode == v) {
          this.getNickName(this.channels[v].shareInitiator, v);
        } else {
          this.getNickName(v);
        }
      });

      // 存在live的大屏
      if (this.outputSourceType) {
        this.allRtilList = rtilCodes;
        if (this.outputSourceType == 'Pbp') {
          this.outputRtilList.forEach(val => {
            if ((typeof val.rtilCode == 'string' || val.rtilCode instanceof Array) && !this.allRtilList.includes(val.rtilCode) && val.rtilCode.includes('mainWindow')) {
              this.allRtilList.push(val.rtilCode);
            }
          });
        }
      } else {
        this.allRtilList = rtilCodes.concat(['mainWindow']);
      }
      // 为了 global control 添加的特殊逻辑
      // 根据 globalControl 的 output 时间和 子会议的  output 时间做对比来显示 mianwindow
      this.dealMainWindow(result);
    });
    Bus.$on('wholePageFullScreen', data => {
      this.showChatMessage = false;
      this.pipsListFullScreen = data;
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.behaviorInfo, val.mark, val.value);
        }
        if (val.key == 'tagName') {
          this.$set(this.tagNameInfo, val.mark, val.value);
        }
        if (this.anyWhereSettings[val.mark] && val.key in this.anyWhereSettings[val.mark]) {
          if (val.key === 'whiteBalance') {
            const parsedValue = JSON.parse(val.value);
            this.$set(this.anyWhereSettings[val.mark], val.key, parsedValue);
          } else {
            // Directly set the value for other keys
            this.$set(this.anyWhereSettings[val.mark], val.key, val.value);
          }
        }
      });
    });
    Bus.$on('setOutput', v => {
      const {
        sourceType,
        outputInitiator,
        outputTimestamp
      } = v;
      this.partyOutputTimestamp = outputTimestamp;
      this.outputSourceType = sourceType;
      // 由于viewposition的推送快于setoutput，导致viewposition的逻辑不生效，需要重新定义allRtilList的数据
      this.allRtilList = this.allRtilList.filter(v => v != 'mainWindow');

      // 先清空值
      this.outputRtilCode = '';
      this.outputRtilList = [];
      // 赋值
      if (sourceType == 'Pbp') {
        this.outputRtilList = v.pbpInfo.pbpSources.map(v => {
          return {
            ...v,
            rtilCode: v.rtilCode || `mainWindow${v.position}`
          };
        });
        this.outputRtilList.forEach(val => {
          if (!this.allRtilList.includes(val.rtilCode)) {
            this.allRtilList.push(val.rtilCode);
          }
        });
      } else if (sourceType == 'ShareScreen') {
        this.getNickName(v.rtilCode, outputInitiator);
        this.outputRtilCode = v.rtilCode;
      } else {
        this.outputRtilCode = v.rtilCode;
      }
    });
    Bus.$on('cancelOutput', v => {
      const {
        sourceType
      } = v;
      const _this = this;
      if (_this.globalOutputTimestamp < _this.partyOutputTimestamp) {
        this.outputSourceType = '';
        this.outputRtilCode = '';
      }
      this.outputRtilList = [];
      if (sourceType != 'Participant' && sourceType != 'ShareScreen') {
        // 为了其他host页面可以清空状态
        if (this.State.joinInfo) {
          this.State.joinInfo.status.receiverOutput = '';
        }
      }
      if (sourceType == 'ShareScreen' && this.shareList[v.rtilCode] == this.userInfo.rtilCode && this.shareScreenType == 'mainWindow') {
        this.shareScreenType = '';
      }
      // 先过滤掉所有包含mainwindow的code
      this.allRtilList = this.allRtilList.filter(v => !(v + '').includes('mainWindow'));
      if (!this.allRtilList.includes('mainWindow') && !this.outputRtilCode) {
        this.allRtilList = this.allRtilList.concat('mainWindow');
      }
    });
    Bus.$on('endParty', val => {
      this.selectRid = '';
      this.selectOutputType = 'VFB';
      this.outputRtilCode = '';
      this.shareScreenType = null;
      this.shareList = {};
      this.allRtilList = ['mainWindow'];
      this.loadChatBox = false;
      this.isShare = false;
      this.cancelStopShare();
      this.shareClient && this.shareClient.leave();
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('responseControlBehavior', v => {
      const {
        key,
        rtilCode,
        responseCode,
        senderRtilCode
      } = v;
      // 为了兼容anywhere，目前anywhere不会传递host的rtilCode，所以直接提示，之后添加就给rtiCode == -1添加去掉
      if (rtilCode == this.userInfo.rtilCode || rtilCode == -1) {
        if (key === 'camera') {
          if (responseCode == 2) {
            this.$set(this.State.cameraStatus, senderRtilCode, false);
            this.$message.warning(this.$t('kioskHost.requestDeny'));
          }
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationCameraFailed'));
          }
        }
        if (key == 'mic') {
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationMicroFailed'));
          }
        }
      }
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.currentPartyInfo.code) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        toEmail
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      } else {
        if (status === 1) {
          this.$message.success(toEmail + this.$t('personalInfo.accepted'));
        } else if (status === 2) {
          this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
        }
      }
    });
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave());
          }
          this.joinParam.status.cloudProxy = 1;
          this.getMeetingInfo(this.joinParam, this.externalJoinInfo);
        } else {
          this.hadOpenWebCloud = false;
          for (const k in this.rtc) {
            this.rtc[k] && (await this.rtc[k].leave('closeCLoudProxy'));
          }
          this.joinParam.status.cloudProxy = 0;
          this.getMeetingInfo(this.joinParam, this.externalJoinInfo);
        }
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.isAudioLevel = true;
        } else {
          this.isAudioLevel = false;
        }
      }
    });
    Bus.$on('startPushStreamFromGlobalControl', v => {
      const {
        outputSource,
        output,
        outputTimestamp,
        sourceType
      } = v;
      // 先清空值
      this.outputRtilCode = '';
      this.outputRtilCode = output;
      this.outputSourceType = outputSource;
      if (sourceType != 'Tag') {
        this.globalOutputTimestamp = outputTimestamp;
      }
      // 由于viewposition的推送快于setoutput，导致viewposition的逻辑不生效，需要重新定义allRtilList的数据
      if (sourceType != 'Tag') {
        this.allRtilList = this.allRtilList.filter(v => v != 'mainWindow');
        this.getGlobalAgoraToken(v);
      }
    });
    Bus.$on('stopPushStreamFromGlobalControl', v => {
      var _this$viewPosition$gl;
      const {
        outputSource,
        partyCode,
        sourceType
      } = v;
      if (sourceType == 'Tag') {
        this.outputRtilCode = '';
      }
      if (this.globalOutputTimestamp > this.partyOutputTimestamp && (_this$viewPosition$gl = this.viewPosition.globalControlOutput) !== null && _this$viewPosition$gl !== void 0 && _this$viewPosition$gl[0]) {
        this.outputSourceType = '';
        this.outputRtilCode = '';
      }
      if (outputSource != 'Participant' && outputSource != 'ShareScreen') {
        // 为了其他host页面可以清空状态
        if (this.State.joinInfo) {
          this.State.joinInfo.status.receiverOutput = '';
        }
      }
      if (outputSource == 'ShareScreen' && this.shareList[v.rtilCode] == this.userInfo.rtilCode && this.shareScreenType == 'mainWindow') {
        this.shareScreenType = '';
      }
      // 先过滤掉所有包含mainwindow的code
      this.allRtilList = this.allRtilList.filter(v => !(v + '').includes('mainWindow'));
      if (!this.allRtilList.includes('mainWindow')) {
        this.allRtilList = this.allRtilList.concat('mainWindow');
      }
      if (this.rtc[partyCode]) {
        this.rtc[partyCode].leave();
        this.$delete(this.rtc, partyCode);
      }
    });
    // globalControl 相关消息推送 开始
    Bus.$on('fullScreenFromGlobalControl', v => {
      this.State.globalFullScreen = !!v.operateType;
      this.$refs.participantList.changeFullScreen(v.operateType);
    });
    Bus.$on('addToGlobalControl', v => {
      const {
        globalControlId,
        partyCode,
        mainWindowOutputParam,
        mute
      } = v;
      const {
        outputSource,
        output,
        outputTimestamp,
        partyOutputTimestamp
      } = mainWindowOutputParam;
      if (partyCode == this.userInfo.joinCode) {
        this.globalControlId = globalControlId;
        this.userInfo.globalControl = {};
        // 新加入时根据有没有 Global control mainWindow 来调取接口
        const _this = this;
        if (!_this.rtc[mainWindowOutputParam.partyCode] && outputTimestamp > partyOutputTimestamp) {
          this.outputSourceType = outputSource;
          this.State.outputCode = output;
          this.getGlobalAgoraToken({
            partyCode: mainWindowOutputParam.partyCode
          });
        }
        this.dealMainWindow({
          globalControlOutputTimestamp: mainWindowOutputParam.outputTimestamp,
          outputTimestamp: mainWindowOutputParam.partyOutputTimestamp,
          globalControlOutput: this.viewPosition.globalControlOutput,
          output: this.viewPosition.output
        });
        setTimeout(() => {
          this.State.pageSerBusRequestWs[this.userInfo.joinCode] && this.State.pageSerBusRequestWs[this.userInfo.joinCode].close();
          this.$delete(this.State.pageSerBusRequestWs, this.userInfo.joinCode);
        }, 2000);
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode,
          globalControlId
        });
        if (mute && this.mic) {
          this.changeMeMute('notNeedChange');
          this.State.globalMute = true;
        } else if (!mute && !this.mic) {
          this.changeMeMute('notNeedChange');
          this.State.globalMute = true;
        }
      }
    });
    Bus.$on('removeFromGlobalControl', v => {
      const {
        partyCode,
        mainWindowOutputParam,
        globalControlId
      } = v;
      const {
        outputTimestamp,
        partyOutputTimestamp
      } = mainWindowOutputParam;
      if (partyCode == this.userInfo.joinCode) {
        this.globalControlId = '';
        if (outputTimestamp > partyOutputTimestamp && mainWindowOutputParam.output) {
          this.outputSourceType = '';
          this.outputRtilCode = '';
        }
        this.userInfo.globalControl = null;
        this.State.globalMute = false;
        this.dealMainWindow({
          globalControlOutputTimestamp: mainWindowOutputParam.outputTimestamp,
          outputTimestamp: mainWindowOutputParam.partyOutputTimestamp,
          globalControlOutput: this.viewPosition.globalControlOutput,
          output: this.viewPosition.output
        });
        setTimeout(() => {
          this.State.pageSerBusRequestWs[globalControlId] && this.State.pageSerBusRequestWs[globalControlId].close();
          this.$delete(this.State.pageSerBusRequestWs, globalControlId);
        }, 2000);
        // 移除需要恢复状态
        const _this = this;
        if (_this.mic != _this.oldMuteMicStatus) {
          this.changeMeMute('notNeedChange');
        }
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode
        });
      }
    });
    Bus.$on('muteFromGlobalControl', v => {
      // 首先根据 val 来进行判断是 mute 还是 unmute
      const {
        partyCodes,
        operateType
      } = v;
      if (operateType) {
        // 在区分当前是 mute all 还是 mute 部分, partyCode 为空代表 mute all
        if (partyCodes.length == 0) {
          // 如果之前没有 mute 过在执行 mute 操作
          if (!this.State.globalMute || this.mic) {
            this.State.globalMute = true;
            this.mic = false;
            this.setLocalAudio(false);
          }
        } else {
          // 如果当前 mute 的是部分则有以下需要判断
          // 1. 已经 mute 过的不需要在 mute 一次
          // 2. 之前已经 mute 但不在当前 mute 列表的需要取消 mute
          const _this = this;
          if (partyCodes.includes(Number(_this.userInfo.joinCode)) && (!_this.State.globalMute || _this.mic)) {
            this.State.globalMute = true;
            this.mic = false;
            this.setLocalAudio(false);
          }
        }
      } else {
        // 取消所有
        if (partyCodes.length == 0) {
          // 如果当前处于 mute 状态那么也需要执行
          if (this.State.globalMute || !this.mic) {
            this.State.globalMute = false;
            this.mic = true;
            this.setLocalAudio(true);
          }
        } else {
          // 如果当前 unmute 的是部分则有以下需要判断
          // 1. 已经 unmute 的不需要在 unmute 一次
          if (partyCodes.includes(Number(this.userInfo.joinCode)) && (this.State.globalMute || !this.mic)) {
            this.State.globalMute = false;
            this.mic = true;
            this.setLocalAudio(true);
          }
        }
      }
    });
    Bus.$on('applyStreamForAll', v => {
      if (v.enable == true) return;
      const {
        output,
        outputTimestamp,
        outputSource,
        partyCode
      } = v;
      this.outputRtilCode = output;
      this.globalOutputTimestamp = outputTimestamp;
      this.viewPosition.globalControlOutputTimestamp = outputTimestamp;
      this.dealMainWindow(this.viewPosition);
      if (!this.rtc[partyCode]) {
        this.outputSourceType = outputSource;
        this.State.outputCode = output;
        if (sourceType != 'Tag') {
          this.getGlobalAgoraToken({
            partyCode
          });
        }
      }
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
      }
    });
  },
  methods: {
    closeAnywherePreview() {
      // 恢复的列表对象赋值给channels
      this.$set(this.channels, this.anyWhereInfo.rtilCode, this.anyWhereRtilCodeObj);
      this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
      this.anyWhereInfo.rtilCode = '';
      this.anyWhereVideoAudioInfo = null;
    },
    operateCallback(obj) {
      const {
        type,
        val
      } = obj;
      if (type === 'audioContext') {
        this.localVolume = val;
      }
    },
    getPartyInfo(id, illegalPartyCode) {
      if (!id) return;
      const params = {};
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      this.axios.get(`/partyline-backend/party/${id}`, {
        params
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          const {
            code,
            title,
            id,
            createTime
          } = result;
          this.State.currentPartyInfo = result;
          setTimeout(() => {
            Bus.$emit('changePartyAddress', {
              currentId: code,
              lastId: id,
              init: 'initAside',
              title,
              id,
              createTime
            });
          }, 500);
        }
      });
    },
    // global control 相关功能 开始
    dealMainWindow(v) {
      const {
        globalControlOutputTimestamp,
        outputTimestamp,
        globalControlOutput,
        output
      } = v;
      // 用来处理把 party 添加到 global control 时同步 mainWindow
      if (globalControlOutputTimestamp > outputTimestamp && globalControlOutput !== null && globalControlOutput !== void 0 && globalControlOutput[0]) {
        this.State.outputCode = globalControlOutput[0];
        this.outputRtilCode = globalControlOutput[0];
      }
      if (outputTimestamp > globalControlOutputTimestamp && output !== null && output !== void 0 && output[0]) {
        this.State.outputCode = output[0];
        this.outputRtilCode = output[0];
      }
      if (this.userInfo.globalControl) {
        if (globalControlOutputTimestamp || outputTimestamp) {
          if (globalControlOutputTimestamp > outputTimestamp) {
            this.allRtilList = this.viewPosition.total.filter(rtilCode => {
              return rtilCode != (output === null || output === void 0 ? void 0 : output[0]);
            });
            if (!(globalControlOutput !== null && globalControlOutput !== void 0 && globalControlOutput[0]) && !this.allRtilList.includes('mainWindow')) {
              this.allRtilList = this.allRtilList.concat(['mainWindow']);
            }
          } else {
            this.allRtilList = this.viewPosition.total.filter(rtilCode => {
              return rtilCode != (globalControlOutput === null || globalControlOutput === void 0 ? void 0 : globalControlOutput[0]);
            });
            if (!(output !== null && output !== void 0 && output[0]) && !this.allRtilList.includes('mainWindow')) {
              this.allRtilList = this.allRtilList.concat(['mainWindow']);
            }
          }
        }
      }
    },
    showFullScreenTips() {
      this.fullScreenTips.show = true;
      this.$refs.participantList.changeFullScreen(0);
    },
    setFullScreen() {
      this.$refs.participantList.changeFullScreen(1);
    },
    getGlobalAgoraToken(globalInfo) {
      // 先掉借口获取加入 agora 的参数
      const params = {
        memberId: this.loginInfo.id || 'PL_' + new Date().getTime(),
        partyCode: globalInfo.partyCode,
        role: 0,
        type: 3
      };
      this.axios.post('/partyline-backend/party/v2/noLogin/agoraTokenGenerate', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          this.joinGlobalParty(res.data.result, globalInfo);
        }
      });
    },
    async joinGlobalParty(info, globalInfo) {
      this.rtc[globalInfo.partyCode] = new AgoraClient(this.callBack);
      const {
        appId,
        tokenCode,
        rtilCode,
        videoQualities
      } = info;
      const params = {
        appId: appId,
        channel: globalInfo.partyCode + '',
        token: tokenCode,
        uid: rtilCode,
        videoConfig: videoQualities,
        publishAudio: false,
        // 始终在realparty内发流
        publishVideo: false,
        // 始终在realparty内发流
        getRemoteNetworks: true
      };
      await this.rtc[globalInfo.partyCode].join(params);
    },
    // global control 相关功能 结束
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    calculatorArea() {
      Tool.judgeVerticalScreen();
      this.$refs.rightAside.resizeLogoArea();
      this.$refs.participantList.resizeUi(this.outputSourceType);
    },
    mainwindowSelectCallback({
      type,
      id
    }) {
      if (type == 'stopShare') {
        this.stopShare({
          id
        }, true);
      }
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        if (this.$route.name != 'kiosk') clearInterval(this.wsPageSTimer);

        // 发送liveRtilCodes
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: this.allRtilList.filter(v => !(v + '').includes('mainWindow')),
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name == 'kiosk') {
          socket.send(params);
        }
      }, 1000);
    },
    dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.changeMeMute();
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'shareScreen':
          if (this.outputSourceType == 'Pbp' && shareType == 'mainWindow') {
            return;
          }
          this.shareScreen(shareType, shareType); // 第一个shareType是分享 pip 还是 mainWindow， 第二个是用于点击 stopShareIcon 停掉分享
          break;
        case 'showChat':
          this.State.showChatMessage = val;
          if (val) {
            this.showUnread = false;
            this.loadChatBox = true;
          }
          break;
      }
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'unreadInfo') {
        let showUnread = false;
        Bus.$emit('chatUnread', false);
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            showUnread = true;
            Bus.$emit('chatUnread', showUnread);
            this.showUnread = showUnread;
          }
        });
      }
    },
    switchDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // 与会者切换
        this.$refs.participantList.setPipUser();
      }
      if (!this.devicesInfo.cameraId) {
        this.State.guideObjShow = true;
      } else {
        Object.keys(this.rtc).forEach(key => {
          this.rtc[key] && this.rtc[key].setDevice(obj.deviceId, obj.type);
        });
      }
    },
    saveTagName(obj) {
      this.$set(this.tagNameInfo, obj.rtilCode, obj.tagName);
    },
    changeMute(flag) {
      if (!this.userInfo.rtilCode || !this.groupId) return;
      // 更改状态
      this.$store.dispatch('isMute', !this.State.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.groupId,
        key: 'speaker',
        value: !this.State.isMute
      }];
      if (!this.groupId) return;
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params);
    },
    async changeMeMute(notNeedChange) {
      // 更新状态
      if (!this.rtc[this.userInfo.realPartyCode] && !this.rtc) return;
      if (!this.devicesInfo.microphoneId) {
        if (this.devicesInfo.microphoneError == 'PERMISSION_DENIED') {
          this.State.guideObjShow = true;
        } else {
          this.$message.error('No microphone available');
        }
        return;
      }
      if (this.State.globalMute) {
        this.$message.warning(this.$t('common.failedInGlobal'));
        return;
      }
      this.mic = !this.mic;
      if (!notNeedChange) this.oldMuteMicStatus = !this.oldMuteMicStatus;
      let operationResult = 'success';
      const rtc = this.rtc[this.userInfo.realPartyCode];
      if (this.mic) {
        if (rtc._localAudioTrack) {
          operationResult = await controlDevicePublish(rtc, 'publish', [rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(rtc, this.devicesInfo, true, result => {
            if (result == 'failed') {
              operationResult = 'failed';
            }
          });
        }
      } else {
        operationResult = await controlDevicePublish(rtc, 'unpublish', [rtc._localAudioTrack]);
      }
      if (operationResult === 'success') {
        this.userInfo.rtilCode && controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value: this.mic,
          partyCode: this.groupId,
          toRtilCode: this.userInfo.rtilCode,
          origin: 'kioskHost'
        });
      } else {
        this.mic = !this.mic;
        this.oldMuteMicStatus = !this.oldMuteMicStatus;
        this.$message.warning(this.$t('common.operationFailed'));
      }
    },
    async setLocalAudio(value) {
      let operationResult = 'success';
      const type = value ? 'publish' : 'unpublish';
      const rtc = this.rtc[this.realPartyCode];
      if (value) {
        if (rtc._localAudioTrack) {
          operationResult = await controlDevicePublish(rtc, 'publish', [rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(rtc, this.devicesInfo, value, result => {
            if (result == 'failed') operationResult = 'failed';
          });
        }
      } else {
        operationResult = await controlDevicePublish(rtc, type, [rtc._localAudioTrack]);
      }
      if (operationResult === 'success') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value,
          partyCode: this.userInfo.joinCode,
          toRtilCode: this.userInfo.rtilCode,
          changeState: true
        });
      } else {
        this.$set(this.State.micStatus, this.userInfo.rtilCode, value);
        this.oldMuteMicStatus = value;
        this.$message.warning(this.$t('common.operationFailed'));
      }
    },
    initJoinFn(newVal) {
      if (!newVal && (newVal + '').length != 12) return;
      this.groupId = newVal;
      this.partyCode = newVal;
      this.shareScreenType = null;
      this.joinParty();
    },
    async getOnlineMember() {
      await this.axios.get('/partyline-backend/kiosk/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          var _res$data$result$view;
          const list = (_res$data$result$view = res.data.result.viewPosition) === null || _res$data$result$view === void 0 ? void 0 : _res$data$result$view.total;
          this.viewPosition = res.data.result.viewPosition;
          this.allRtilList = list.map(v => {
            if (!this.channels[v]) {
              this.$set(this.channels, v, {
                id: v
              });
            }
            if (this.State.cameraStatus[v] != false) {
              this.$set(this.State.cameraStatus, v, true);
            }
            if (this.State.micStatus[v] != false) {
              this.$set(this.State.micStatus, v, true);
            }
            this.getNickName(v);
            return v;
          });
          if (!this.outputSourceType) {
            this.allRtilList = this.allRtilList.concat(['mainWindow']);
          }
          if (this.outputSourceType == 'Pbp') {
            this.outputRtilList.forEach(val => {
              if (!this.allRtilList.includes(val.rtilCode)) {
                this.allRtilList.push(val.rtilCode);
              }
            });
          }
          // 为了 global control 添加的特殊逻辑
          this.dealMainWindow(res.data.result.viewPosition);
        }
      });
    },
    calculatorWidthHeight(logoInfo, type) {
      let {
        realX,
        realY,
        realWidth,
        realHeight
      } = logoInfo;
      if (type === 'send') {
        realX = Number((realX / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realY = Number((realY / this.State.kioskSideBarInfo.height * 100).toFixed(2));
        realWidth = Number((realWidth / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realHeight = Number((realHeight / this.State.kioskSideBarInfo.height * 100).toFixed(2));
      } else {
        realX = Number((realX * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realY = Number((realY * this.State.kioskSideBarInfo.height / 100).toFixed(0));
        realWidth = Number((realWidth * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realHeight = Number((realHeight * this.State.kioskSideBarInfo.height / 100).toFixed(0));
      }
      return {
        realX,
        realY,
        realWidth,
        realHeight
      };
    },
    async joinParty() {
      this.bestOffset = 0;
      this.hasGetTimeOffset = false;
      const partyCode = this.currentPartyInfo.code;
      this.$store.dispatch('checkEnv', {
        partyCode
      });
      // 清除之前的rtc
      for (const k in this.rtc) {
        this.rtc[k] && this.rtc[k].leave();
        delete this.rtc[k];
      }
      const params = {
        memberId: this.loginInfo.id,
        partyCode: this.partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'flipVideo']
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.State.partyJoinInfo = result;
          const {
            rtilCode,
            realPartyCode,
            externalJoinInfo,
            status,
            behavior
          } = result;
          // 创建通知websocket
          if (result.globalControl) {
            this.globalControlId = result.globalControl.id;
            Bus.$emit('createWs', {
              ...this.Config,
              partyCode: result.joinCode,
              globalControlId: result.globalControl.id
            });
          } else {
            Bus.$emit('createWs', {
              ...this.Config,
              partyCode: result.joinCode
            });
          }
          result.status.volumeEffect === 0 ? this.isAudioLevel = true : this.isAudioLevel = false;
          this.$set(this.degreeHost, result.rtilCode, behavior.flipVideo);
          this.allPartyMembers.unshift(result.rtilCode);
          if (this.State.hadLoadPartyList) {
            this.State.newPageLoading = false;
          }
          addTabTitle({
            userInfo: result
          });
          this.State.partyTag = status.partyTag;
          // 传递初始化数据
          Bus.$emit('initOperateData', status);
          Bus.$emit('getCollaborateInfo');
          // 清除share的状态
          if (status.outputSource == 'ShareScreen') {
            this.outputRtilCode = status.output;
            this.stopShare({
              id: status.output
            });
            status.output = '';
            status.outputSource = '';
          }
          // output
          if (status.outputSource == 'Pbp') {
            this.outputRtilList = status.multiOutput.pbpSources.map(v => {
              return {
                ...v,
                rtilCode: v.rtilCode || `mainWindow${v.position}`
              };
            });
          } else {
            this.outputRtilCode = status.output; // 关闭页面需要后台定时清除，share状态不准确
          }

          this.outputSourceType = status.outputSource; // share根据rtilCOde查询memberId，状态准确
          this.externalPartyCode = externalJoinInfo.join;
          this.externalJoinInfo = externalJoinInfo;
          this.realPartyCode = realPartyCode;
          this.userInfo = result;
          // globalControl 的情况下再去执行以下代码
          if (result.globalControl) {
            const {
              outputSource,
              output,
              fullScreen
            } = result.globalControl;
            if (output) {
              this.globalOutputTimestamp = result.globalControl.outputTimestamp;
              this.partyOutputTimestamp = result.status.outputTimestamp || 0;
              if (this.globalOutputTimestamp > this.partyOutputTimestamp || !this.partyOutputTimestamp) {
                this.outputSourceType = outputSource;
                this.outputRtilCode = output;
                this.State.outputCode = output;
                this.State.globalisFullScreen = fullScreen;
                this.getGlobalAgoraToken(result.globalControl);
              }
            }
          }
          this.rtc[realPartyCode] = new AgoraClient(this.callBack);
          this.devicesInfo = await this.rtc[realPartyCode].getDevice();
          if (!handleLocalStorage('get', 'speakerId')) {
            handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
          }
          await this.getOnlineMember();

          // 为了在gallery模式下记录userInfo
          Bus.$emit('saveUserInfo', res.data.result);
          // 获取初始化的一些状态
          Bus.$emit('getInitStatus', {
            videoQuality: result.status.videoQuality || 'low'
          });
          // 用于向别的组件传递初始化数据
          this.freeTalk = false;
          if (result.layoutName == '2-2') {
            this.freeTalk = result.status.freeTalk;
          }
          Bus.$emit('updateInitStatus', {
            freeTalk: result.status.freeTalk
          });
          // 默认显示耳机 默认设置host为crew
          this.State.crewInfo.rtilCode = rtilCode;
          this.State.currentRtilCode = rtilCode;
          this.State.joinInfo = res.data.result;
          this.State.partyCode = result.joinCode;
          this.State.globalMute = status.globalControlMute === '1';
          this.rtilCode = rtilCode;
          this.State.isMute = res.data.result.behavior.speaker === 'false';
          this.mic = res.data.result.behavior.mic !== 'false';
          this.oldMuteMicStatus = res.data.result.behavior.mic === 'true';
          this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 0;
          this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = behavior.checkAudioShare !== 'false';
          Bus.$emit('changeAudioTypeVal');
          if (status.setBar) {
            this.State.hasKioskSideBar = true;
          }
          // 新增为了上传logo
          if (status.logos) {
            status.logos.logos.forEach(item => {
              item.active = true;
              this.State.hadSelectUpLogo.push(item.name);
              const {
                width,
                height
              } = this.dealLogoWH(item);
              item.realWidth = width;
              item.realHeight = height;
              const {
                realX,
                realY,
                realWidth,
                realHeight
              } = this.calculatorWidthHeight(item, 'resume');
              item.realX = realX;
              item.realY = realY;
              item.realWidth = realWidth;
              item.realHeight = realHeight;
              item.isApply = true;
              item.isAdd = true;
              this.State.selectLogoInfo[item.name] = JSON.parse(JSON.stringify(item));
            });
            this.initLogoList = status.logos.logos;
            const newArray = JSON.parse(JSON.stringify(status.logos.logos));
            this.firstLogoList = newArray;
          } else {
            this.initLogoList = [];
            this.firstLogoList = [];
          }
          if (status.background) {
            this.initBackgroundImg = JSON.parse(JSON.stringify(status.background));
            status.background.active = true;
            this.State.hadSelectUpBg = status.background;
            this.$refs.kioskBox.style.background = `#010101 url(${status.background.url}) no-repeat`;
            this.$refs.kioskBox.style.backgroundSize = 'cover';
          } else {
            this.$refs.kioskBox.style.background = '#010101';
          }
          if (status.outputSource === 'Participant') {
            this.selectOutputType = 'PIP';
          } else if (status.outputSource === 'PGM') {
            this.selectOutputType = 'PP';
          }
          this.$set(this.behaviorInfo, rtilCode, 'host');

          // 自己是否在私聊
          if (status.privateConversation) {
            this.State.privateInfo = JSON.parse(status.privateConversation);
          } else {
            this.State.privateInfo = {};
          }
          // 是否存在别人在私聊
          if (!this.State.privateInfoByOthers.length) {
            if (status.privateConversations) {
              this.State.privateInfoByOthers = JSON.parse(status.privateConversations);
            } else {
              this.State.privateInfoByOthers = [];
            }
          }
          handleLocalStorage('set', 'manageRtilCode', res.data.result.managerRtils);
          sessionStorage.setItem('isHost', result.owner);
          // this.createdPartyLineRequest()

          // join agora party
          this.joinParam = {
            ...res.data.result,
            memberId: params.memberId,
            partyCode: params.partyCode
          };
          this.getMeetingInfo(this.joinParam, externalJoinInfo);
        }
      });
    },
    async getMeetingInfo(param, externalJoinInfo) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      // 如果没有摄像头，则默认图标禁用
      this.mic = this.devicesInfo.microphoneId ? this.mic : false;
      this.oldMuteMicStatus = !this.devicesInfo.microphoneId ? true : !this.oldMuteMicStatus;
      const params = {
        appId: appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        videoConfig: videoQualities,
        video: false,
        audio: !!this.devicesInfo.microphoneId,
        getRemoteNetworks: true,
        publishAudio: this.mic,
        // 目前逻辑默认host在real里面发流（包括私聊），extra只用来接受流，不做流的发布
        startProxy: param.status.cloudProxy === 1,
        executeLocalSubscribe: true
      };
      const uid = await this.rtc[realPartyCode].join(params);
      if (uid) {
        var _this$userInfo$videoQ, _this$userInfo$videoQ2;
        this.hadOpenWebCloud = param.status.cloudProxy === 1;
        this.rtcLoaded = true;
        // join到额外的party
        this.rtc[realPartyCode]._client && this.rtc[realPartyCode]._client.enableAudioVolumeIndicator();
        if (this.State.globalMute && this.mic) {
          setTimeout(() => {
            this.mic = false;
            this.oldMuteMicStatus = true;
            this.setLocalAudio(false);
          }, 1000);
        }
        this.getChatMettingInfo(externalJoinInfo);
        /// 更改hostjr userId
        const userId = rtilCode + '_gallery_' + realPartyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        if (!this.hasGetTimeOffset) {
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
        }
        const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
        const intervalTime = fps ? Math.round(1000 / fps) : 33;
        if (this.sendMetadataTimer[realPartyCode]) clearInterval(this.sendMetadataTimer[realPartyCode]);
        this.sendMetadataTimer[realPartyCode] = setInterval(() => {
          this.sendMetadata(realPartyCode);
        }, intervalTime);
      }
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata(realPartyCode) {
      var _this$rtc$realPartyCo, _this$rtc$realPartyCo2;
      if (!((_this$rtc$realPartyCo = this.rtc[realPartyCode]) !== null && _this$rtc$realPartyCo !== void 0 && _this$rtc$realPartyCo.hasJoined)) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$realPartyCo2 = this.rtc[realPartyCode]._client) === null || _this$rtc$realPartyCo2 === void 0 ? void 0 : _this$rtc$realPartyCo2.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    dealLogoWH(item) {
      const obj = {
        width: 66,
        height: 66
      };
      // 首先判断是否有操作过的 realWidth， realHeight
      if (item.realWidth) {
        obj.width = item.realWidth;
        obj.height = item.realHeight;
        return obj;
      } else {
        if (item.width < 66 && item.height < 66) {
          obj.width = item.width;
          obj.height = item.height;
          return obj;
        }
        if (item.width >= 66) {
          obj.width = 66;
          obj.height = parseInt(item.height * 66 / item.width);
          return obj;
        }
        if (item.height >= 66) {
          obj.height = 66;
          obj.width = parseInt(item.width * 66 / item.height);
          return obj;
        }
      }
    },
    createdPartyLineRequest() {
      if (this.PartyLineRequest || !this.Config.urlInfo) return;
      const taskId = Tool.return32Str();
      const url = `wss://${this.Config.urlInfo.ccWebsocket}/partyLineRequest?taskId=${taskId}&partyCode=${-1}&rtilCode=${this.rtilCode}&groupId=${this.partyCode}&isHost=true`;
      this.PartyLineRequest = Tool.createWs(url);
      this.updataStatusTimer = setInterval(() => {
        if (this.PartyLineRequest && this.PartyLineRequest.client.readyState === 1) {
          this.PartyLineRequest.send(3); // partyline心跳
        }
      }, 5000);
    },
    createdPageRequest() {
      const taskId = Tool.return32Str();
      if (!this.Config.urlInfo) return;
      const url = 'wss://' + this.Config.urlInfo.ccWebsocket + '/pageRequest?taskId=' + taskId;
      this.socket = Tool.createWs(url);
      this.updataInfoTimer = setInterval(() => {
        if (this.socket.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              peerIds: [] // this.sourceIds.concat(this.sourceTIds).join(',')
            }
          };

          this.socket.send(params);
        }
      }, 5000);
    },
    subscribeTrack(payload) {
      try {
        // 创建可以播放的mediastream
        const {
          videoTrack,
          audioTrack,
          id
        } = payload;
        let obj = {};
        obj = Object.assign({}, this.channels[payload.id], {
          id: payload.id
        }, {
          channel: payload.channel
        });
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        // anyWhereSetting弹窗中anyWhere离开后音视频流可以自动恢复
        if (this.anyWhereInfo.show && id == this.anyWhereInfo.rtilCode) {
          this.anyWhereVideoAudioInfo = obj;
        }
        this.$set(this.channels, payload.id, obj);
      } catch (error) {
        console.info('addview error', error);
      }
    },
    userJoin(payload) {
      if (!payload.id) return;
      // 初始化camera和miro的状态
      if (this.State.cameraStatus[payload.id] != false) {
        this.$set(this.State.cameraStatus, payload.id, true);
      }
      if (this.State.micStatus[payload.id] != false) {
        this.$set(this.State.micStatus, payload.id, true);
      }
      this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          const accountId = result.accountId.toLowerCase();
          const type = returnSourceType(result);
          this.$set(this.deviceTypeMap, payload.id, type);
          this.$set(this.State.deviceTypeMap, payload.id, type);
          this.$set(this.deviceType, payload.id, result.deviceType);
          this.$set(this.devicePlatform, payload.id, result.devicePlatform);
          // anywhereSetting设置
          if (type == 'Anywhere') {
            this.$set(this.anyWherePlatForms, payload.id, result.devicePlatform);
            this.$set(this.anyWherePeerIds, payload.id, result.devicePeerId);
          }
          // 远程控制支持PartylineApp
          if (type == 'App') {
            var _result$accountId;
            this.$set(this.anyWherePeerIds, payload.id, (_result$accountId = result.accountId) === null || _result$accountId === void 0 ? void 0 : _result$accountId.split('_')[1]);
          }
          // 判断是不是share的code,获取nickName
          let shareInitiator = '';
          let shareCode = '';
          if (accountId.indexOf('_sharescreen') > -1) {
            var _accountId$split;
            // 获取是谁发起的share的code
            shareCode = payload.id;
            shareInitiator = (_accountId$split = accountId.split('_sharescreen')) === null || _accountId$split === void 0 ? void 0 : _accountId$split[0];
            this.$set(this.shareList, shareCode, shareInitiator);
            this.getNickName(shareInitiator, payload.id);
          } else {
            this.getNickName(payload.id);
            if (!this.allPartyMembers.includes(payload.id)) {
              this.allPartyMembers.push(payload.id);
            }
          }
          const obj = Object.assign({}, this.channels[payload.id]);
          this.$set(this.channels, payload.id, {
            ...payload,
            ...obj,
            tid: res.data.result.accountId,
            shareInitiator,
            shareCode
          });
        }
      });
    },
    getNickName(id, key, anywhereSetting) {
      if (!this.partyCode) return;
      this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode,
        keys: ['nickName', 'tagName', 'camera', 'mic', 'blockAudio', 'blockVideo', 'flipVideo', 'resolution', 'fps', 'resolutionOptions', 'fpsOptions', 'whiteBalance', 'whiteBalanceRange', 'cameraOptions', 'whiteBalancePredefined', 'lock', 'whiteBalanceAuto', 'cameraPosition', 'defaultView', 'autoFocus', 'focusDistance', 'focusDistanceRange', 'autoExposure', 'exposure', 'exposureRange', 'zoom', 'zoomRange', 'isSupportGimbal', 'speakerVolume', 'speakerStatus', 'gimbalAngleValue', 'gimbalAngleRange'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          if (this.userInfo.managerRtils && (this.userInfo.managerRtils.includes(parseInt(id)) || this.userInfo.managerRtils.includes(parseInt(key)))) {
            result.nickName = result.nickName || 'host';
          }
          if (key) {
            this.$set(this.behaviorInfo, key, result.nickName);
          } else {
            if (!this.behaviorInfo[id]) {
              this.$set(this.degreeHost, id, result.flipVideo);
              this.$set(this.behaviorInfo, id, result.nickName);
            }
            this.$set(this.behaviorInfo, id, result.nickName);
          }
          if (Object.keys(this.shareList).includes(id + '')) {
            this.$set(this.behaviorInfo, id, this.behaviorInfo[this.shareList[id]]);
          }
          // 初始化anyWhereSetting弹窗内的属性值
          this.$set(this.anyWhereSettings, id, {
            fps: result.fps,
            resolution: result.resolution,
            whiteBalance: JSON.parse(result.whiteBalance),
            lock: result.lock,
            whiteBalanceAuto: result.whiteBalanceAuto,
            cameraPosition: result.cameraPosition,
            resolutionOptions: result.resolutionOptions,
            fpsOptions: result.fpsOptions,
            whiteBalanceRange: result.whiteBalanceRange,
            cameraOptions: result.cameraOptions,
            whiteBalancePredefined: result.whiteBalancePredefined,
            defaultView: result.defaultView,
            autoFocus: result.autoFocus,
            focusDistanceRange: result.focusDistanceRange,
            focusDistance: result.focusDistance ? result.focusDistance : 0,
            autoExposure: result.autoExposure,
            exposureRange: result.exposureRange,
            exposure: result.exposure ? result.exposure : 0,
            zoom: result.zoom ? result.zoom : 0,
            zoomRange: result.zoomRange,
            isSupportGimbal: result.isSupportGimbal,
            speakerVolume: result.speakerVolume ? result.speakerVolume : 100,
            speakerStatus: result.speakerStatus,
            gimbalAngleValue: result.gimbalAngleValue,
            gimbalAngleRange: result.gimbalAngleRange
          });
          if (anywhereSetting) {
            this.anyWhereInfo.show = true;
          }
          this.$set(this.tagNameInfo, id, result.tagName);
        }
      });
    },
    getChatMettingInfo(externalJoinInfo) {
      const externalList = externalJoinInfo.externalPartyInfo;
      externalList.map(async v => {
        const {
          appId,
          tokenCode,
          realPartyCode,
          rtilCode,
          videoQualities
        } = v.joinInfo;
        // host默认在extralparty内推流,私聊则在real party内发流
        const params = {
          appId: appId,
          channel: realPartyCode + '',
          token: tokenCode,
          uid: rtilCode,
          video: false,
          audio: false,
          publish: false,
          // extra只用来接受流，不做流的发布
          videoConfig: videoQualities,
          executeLocalSubscribe: true,
          executeVideoAdded: true
        };
        // id更换channel
        this.rtc[realPartyCode] = new AgoraClient(this.callBack);
        const uid = await this.rtc[realPartyCode].join(params);
        if (uid) {
          this.rtcLoaded = true;
        }
      });
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType,
        channel
      } = payload;
      const value = action === 'user-published';
      if (!value && mediaType == 'video' && channel == this.realPartyCode) {
        this.$set(this.channels, id, {
          ...this.channels[id],
          videoTrack: null
        });
      }
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, value) : this.$set(this.State.micStatus, id, value);
    },
    attendCallback(obj) {
      let {
        type,
        id,
        val
      } = obj;
      if (type == 'muteAudio') {
        if (this.State.globalMute) {
          this.$message.warning(this.$t('common.failedInGlobal'));
          return;
        }
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value: val,
          partyCode: this.userInfo.joinCode,
          toRtilCode: id,
          origin: 'kioskHost'
        });
      } else if (type == 'muteVideo') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'camera',
          value: val,
          partyCode: this.userInfo.joinCode,
          toRtilCode: id,
          origin: 'kioskHost'
        });
      } else if (type === 'editTagName') {
        this.editTagName(obj);
      } else if (type === 'moveParty') {
        id = String(id);
        if (obj.sign == 'batch') {
          // 批量
          if (obj.status) {
            if (!this.batchMovePartyInfo.rtilCodes.includes(id) && id != 'mainWindow2' && id != 'mainWindow1') {
              let flag = true;
              this.outputRtilList.forEach(item => {
                if (item.rtilCode == id) {
                  flag = false;
                }
              });
              if (flag && !this.shareList[id]) this.batchMovePartyInfo.rtilCodes.push(id);
            }
          } else {
            this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
          }
        } else {
          this.movePartyInfo.show = true;
          this.movePartyInfo.rtilCodes = [String(id)];
        }
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      } else if (type === 'anyWhereSetting') {
        this.getNickName(id, '', 'anyWhereSetting');
        this.anyWhereInfo.rtilCode = id;
        this.anyWhereRtilCodeObj = this.channels[id];
        // 将这个音视频流置空
        this.$set(this.channels, id, {});
        setTimeout(() => {
          this.$set(this.anywhereSettingShowMap, id, true);
        }, 500);
        this.anyWhereVideoAudioInfo = {
          rtilCode: id,
          id: id
        };
        // 赋值给anyWhereSetting弹窗对应的列表流
        if (this.rtc[this.userInfo.realPartyCode]._subscribeTrack[id]) {
          const obj = Object.assign({}, this.channels[id]);
          obj.id = id;
          obj.videoTrack = this.rtc[this.userInfo.realPartyCode]._subscribeTrack[id].videoTrack;
          obj.audioTrack = this.rtc[this.userInfo.realPartyCode]._subscribeTrack[id].audioTrack;
          this.anyWhereVideoAudioInfo = obj;
        }
      }
    },
    editTagName(obj) {
      this.setTagName.show = true;
      this.setTagName.originRtilCode = this.userInfo.rtilCode;
      this.setTagName.targetRtilCode = obj.id;
      this.setTagName.partyCode = this.currentPartyInfo.partyCode || this.State.partyCode;
      this.setTagName.tagName = this.tagNameInfo[obj.id];
    },
    async callBack({
      action,
      payload
    }) {
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          Bus.$emit('setSubscribeTrack', payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.muteAudioOrVideo(action, payload);
          break;
        case 'stop-share':
          this.stopShare(payload);
          break;
        case 'start-share':
          this.sendShareViewPosition(payload);
          break;
        case 'local-publish':
          if (payload.type.includes('audio')) {
            this.mic = true;
            this.oldMuteMicStatus = false;
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio')) {
            this.mic = false;
            this.oldMuteMicStatus = true;
          }
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          this.$set(this.channels, this.userInfo.rtilCode, {
            id: this.userInfo.rtilCode
          });
          videoTrack && this.$set(this.channels[this.userInfo.rtilCode], 'videoTrack', videoTrack);
          audioTrack && this.$set(this.channels[this.userInfo.rtilCode], 'audioTrack', audioTrack);
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localVideoTrack && changeDevice.device.label === this.rtc[this.realPartyCode]._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc[this.realPartyCode]._AgoraRTC.getCameras();
            (oldCameras === null || oldCameras === void 0 ? void 0 : oldCameras[0]) && this.rtc[this.realPartyCode].setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          if (!this.rtc || !this.rtc[this.realPartyCode]) return;
          this.devicesInfo = await this.rtc[this.realPartyCode].getDevice();
          if (this.rtc[this.realPartyCode]._localAudioTrack && (this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId == 'default')) {
            const oldMic = await this.rtc[this.realPartyCode]._AgoraRTC.getMicrophones();
            (oldMic === null || oldMic === void 0 ? void 0 : oldMic[0]) && this.rtc[this.realPartyCode].setDevice(oldMic[0].deviceId, 'audio', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc[this.realPartyCode]._localAudioTrack && !this.rtc[this.realPartyCode]._localAudioTrack._deviceName.includes(changeDevice.device.label) && this.rtc[this.realPartyCode]._localAudioTrack._config.microphoneId != 'default') {
            var _this$devicesInfo$mic;
            // 插入mic
            if (!this.isMeMute) {
              this.rtc[this.userInfo.realPartyCode].setEnabled(false, 'audio');
              this.rtc[this.userInfo.realPartyCode].setEnabled(true, 'audio');
            }
            if (((_this$devicesInfo$mic = this.devicesInfo.microphoneList) === null || _this$devicesInfo$mic === void 0 ? void 0 : _this$devicesInfo$mic[0].label) != this.rtc[this.realPartyCode]._localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
          }
          break;
        case 'playbackChange':
          const rtc = this.rtc[this.userInfo.realPartyCode];
          if (!rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          if (changeDevice.state !== 'ACTIVE' && rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => {
              var _currentLabelArray$;
              return item.label == ((_currentLabelArray$ = currentLabelArray[0]) === null || _currentLabelArray$ === void 0 ? void 0 : _currentLabelArray$.label);
            });
            if (!haveUseDevice) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo, _this$channels$rtilCo2;
                  (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await rtc.getDevice();
          break;
      }
    },
    sendShareViewPosition({
      channel,
      id,
      shareInfo
    }) {
      const obj = {
        id,
        videoTrack: shareInfo.videoTrack,
        audioTrack: shareInfo.audioTrack
      };
      this.$set(this.channels, id, obj);
      const params = {
        joinType: this.shareScreenType == 'mainWindow' ? 1 : 2,
        partyCode: channel,
        rtilCode: id
      };
      this.axios.post('/partyline-backend/party/noLogin/startShare', params);
    },
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      if (payload.channel == this.realPartyCode) {
        this.$set(this.channels, id, {
          id
        });
      } else {
        this.$set(this.extraChannel, id, {
          id
        });
      }
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
      // 如果当前弹窗开着需要关闭
      if (payload.id == this.anyWhereInfo.rtilCode) {
        this.anyWhereInfo.show = false;
        this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
        this.anyWhereInfo.rtilCode = '';
        this.anyWhereVideoAudioInfo = null;
        this.$message.success(this.$t('anywhereSetting.userLeft'));
      }
      // chat人员
      this.allPartyMembers = this.allPartyMembers.filter(v => v != id);
    },
    stopShare(payload, byClickShareIcon) {
      this.isShare = false;
      this.shareScreenType = null;
      this.$delete(this.shareList, payload.id);
      this.cancalShareCommand(payload.id, byClickShareIcon);
      if (this.outputRtilCode == payload.id) {
        this.sendCancelShareOutput(payload.id);
        this.outputRtilCode = null;
        this.outputSourceType = null;
      }
    },
    cancalShareCommand(id, byClickShareIcon) {
      const params = {
        partyCode: this.partyCode,
        module: 'cancelShareScreen',
        origin: 'kioskHost',
        msg: {
          rtilCode: id
        }
      };
      if (!id) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=74139', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.shareClient && this.shareClient.leave();
          if (byClickShareIcon) {
            this.cancelStopShare();
          }
          this.shareClient = null;
          this.shareRtilCode = '';
          this.$delete(this.shareList, id);
        }
      });
    },
    cancelStopShare() {
      if (this.shareClient && this.shareClient._shareTrack) {
        var _this$shareClient$_sh;
        (_this$shareClient$_sh = this.shareClient._shareTrack._mediaStreamTrack) === null || _this$shareClient$_sh === void 0 ? void 0 : _this$shareClient$_sh.stop();
        this.shareClient && this.shareClient.leave();
      }
    },
    setBgImg(info, flag) {
      if (info && info.url && flag) {
        this.$refs.pipBox.style.background = `#010101 url(${info.url}) no-repeat`;
        this.$refs.pipBox.style.backgroundSize = 'cover';
        this.$refs.kioskBox.style.background = `#010101 url(${info.url}) no-repeat`;
        this.$refs.kioskBox.style.backgroundSize = 'cover';
      } else {
        this.$refs.pipBox.style.background = '';
        this.$refs.kioskBox.style.background = '';
      }
    },
    showFullScreenCloseBtnFn(val) {
      if (this.initShowCloseFullScreenBtn || this.showUploadLogo) return; // 初始化显示3s之后，在执行其他操作
      this.showCloseFullScreenBtn = val;
    },
    controlLogoBox() {
      this.showCloseFullScreenBtn = false;
      this.showUploadLogo = true;
      this.State.showUploadLogo = true;
      this.$refs.rightAside.changePicStatus('setPicture');
    },
    sendBg() {
      this.$refs.leftAside.setBackgroundImg();
    },
    getReceiverList() {
      const params = {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true
      };
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.formatRList(result);
        }
      });
    },
    formatRList(result) {
      var _result$cc$list;
      const array = [];
      this.allRList = [];
      // receiver list
      const receiverObj = {};
      receiverObj.value = 'Receiver';
      receiverObj.label = 'Receiver';
      receiverObj.children = [];
      if ((_result$cc$list = result.cc.list) !== null && _result$cc$list !== void 0 && _result$cc$list.length) {
        result.cc.list.forEach(item => {
          const itemInfo = {
            ...item,
            value: item.peerId,
            label: item.name
          };
          receiverObj.children.push(itemInfo);
        });
        array.push(receiverObj);
      } else {
        receiverObj.disabled = true;
      }
      // pp list
      const ppObj = {};
      ppObj.value = 'Producer';
      ppObj.label = 'Producer';
      if (result.pps && result.pps.length) {
        ppObj.children = this.dealPPList(result.pps);
      } else {
        ppObj.disabled = true;
      }
      array.push(ppObj);
      this.allRList = array;
    },
    dealPPList(list) {
      const array = [];
      list.forEach(item => {
        item.pageInfo.list.forEach(info => {
          this.State.slotList.push(info.rids);
          const ppObj = {};
          ppObj.value = info.receiverId;
          ppObj.label = info.name;
          ppObj.userInfo = item.user;
          ppObj.children = info.rids.map((slotId, index) => {
            return {
              value: slotId,
              label: `Slot${index + 1}`
            };
          });
          array.push(ppObj);
        });
      });
      return array;
    },
    async dealConfirm() {
      this.$refs.mainWindowSelect && (await this.$refs.mainWindowSelect.stopReceiverParty());
      this.outputSourceType = '';
      this.shareScreen('mainWindow');
      this.hasShare = true;
      this.dailogInfo.show = false;
    },
    shareScreen(type, shareType) {
      if (shareType === 'stopShare') {
        this.stopShare({
          id: this.shareScreenType === 'pip' ? this.shareRtilCode : this.outputRtilCode
        }, 'byClickShareIcon');
      } else {
        // 点击完毕之后即关闭popover
        this.sharePopover = false;
        // 当选择share screen的时候需要先判断是否正在send49路视频
        if (this.outputSourceType && type == 'mainWindow') {
          this.hasShare = false;
          // 弹出确认框
          this.dailogInfo.show = true;
          return;
        }
        this.shareScreenType = type;
        if (this.shareClient) {
          if (type == 'mainWindow') {
            this.outputRtilCode = this.shareRtilCode;
            this.sendCommandShare(this.shareRtilCode);
          } else {
            if (this.outputSourceType == 'shareScreen') {
              this.sendCancelShareOutput(this.outputRtilCode);
            }
          }
          return;
        }
        const params = {
          memberId: `${this.userInfo.rtilCode}_sharescreen`,
          partyCode: this.partyCode,
          role: 0,
          type: 3,
          host: false,
          joinType: type == 'mainWindow' ? 1 : 2,
          whetherSendViewPosition: 0
        };
        this.axios.post('/partyline-backend/party/noLogin/join', params, {
          errorTip: false
        }).then(async res => {
          if (res.data.errorCode === '0x0') {
            const {
              appId,
              rtilCode,
              tokenCode
            } = res.data.result;
            if (type == 'mainWindow') {
              this.outputRtilCode = rtilCode;
              this.sendCommandShare(rtilCode);
            } else {
              this.shareRtilCode = rtilCode;
            }
            const temp = {
              appId,
              channel: this.externalPartyCode + '',
              token: tokenCode,
              uid: rtilCode,
              share: true,
              subscribeRemote: false,
              status: this.State.partyJoinInfo.status
            };
            this.shareClient = new AgoraClient(this.callBack);
            await this.shareClient.join(temp);
            this.saveShareName(res.data.result);
            this.$set(this.State.localShareInfo, rtilCode, this.userInfo.rtilCode);
            this.isShare = true;
            this.inonWindow = true;
          }
        });
      }
    },
    saveShareName({
      rtilCode
    }) {
      if (!rtilCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.userInfo.joinCode,
        key: 'nickName',
        notify: true,
        value: this.behaviorInfo[this.userInfo.rtilCode] + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    sendCommandShare(rtilCode) {
      const params = {
        partyCode: this.groupId,
        module: 'setOutput',
        msg: {
          rtilCode: rtilCode,
          sourceType: 'shareScreen'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=92408', params);
    },
    sendCancelShareOutput(rtilCode) {
      const params = {
        partyCode: this.groupId,
        module: 'cancelOutput',
        msg: {
          rtilCode: rtilCode,
          sourceType: 'shareScreen'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=64867', params);
    },
    hideUplogo() {
      this.showUploadLogo = false;
      this.State.showUploadLogo = false;
      // 如果用户没有应用，就把logoList恢复成上一次应用的数组
      this.$refs.rightAside.changePicStatus('back');
      this.$refs.leftAside.setDefault();
      // 用户初始化的时候获取图片，并未设置图片
      if (this.initBackgroundImg && !this.initBackgroundImg.active) {
        this.initBackgroundImg.active = true;
        this.setBgImg(this.initBackgroundImg, this.initBackgroundImg.active);
      } else if (this.initBackgroundImg && this.initBackgroundImg.active) {
        // 用户设置了背景图片，initBackgroundImg中有active
        this.setBgImg(this.initBackgroundImg, this.initBackgroundImg.active);
      } else if (!this.initBackgroundImg) {
        // 无背景图片的时候
        this.setBgImg();
      }
    },
    getOutputList() {
      if (this.selectOutputType === 'VFB' || this.selectOutputType === 'PP') {
        this.getReceiverList();
      } else {
        this.getParticipantsList();
      }
    },
    setfirstLogoList(res) {
      this.firstLogoList = res.logos;
    },
    setInitBackground(info) {
      this.initBackgroundImg = info;
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('isHost');
  },
  beforeRouteLeave(to, from, next) {
    if (this.rtc) {
      for (const k in this.rtc) {
        this.rtc[k] && this.rtc[k].leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '');
        if (this.sendMetadataTimer[k]) clearInterval(this.sendMetadataTimer[k]);
      }
    }
    // 恢复初始设置
    this.State.crewInfo = {};
    this.State.privateInfo = {};
    this.userInfo = {};
    window.devicesInfo;
    window.removeEventListener('resize', this.calculatorArea);
    document.removeEventListener('fullscreenerror', this.showFullScreenTips);
    this.PartyLineRequest && this.PartyLineRequest.close();
    this.State.pageSerBusRequestWs[this.groupId] && this.State.pageSerBusRequestWs[this.groupId].close();
    this.$delete(this.State.pageSerBusRequestWs, this.groupId);
    if (this.onlineTimer) clearInterval(this.onlineTimer);
    if (this.wsPageSTimer) clearInterval(this.wsPageSTimer);
    for (const k in this.rtc) {
      this.rtc[k]._client && this.rtc[k].leave();
    }
    next();
  }
};